export const ClarityUet = {
  sync(state) {
    (window.uetq = window.uetq || []).push(['consent', 'update', { ad_storage: state.marketing ? 'granted' : 'denied' }]);
    if (typeof window.clarity === 'function') {
      window.clarity('consent', !!state.measurement);
    }
  },
};
